// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_UUID from "../Data.UUID/index.js";
import * as Effect from "../Effect/index.js";
var newIdGenerator = function (dict) {
    return dict.newIdGenerator;
};
var generateUUID = {
    newIdGenerator: /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect)(Data_UUID.genUUID)
};
export {
    newIdGenerator,
    generateUUID
};
